import { getMomentTz } from "@dexteel/mesf-core";
import { Grid } from "@material-ui/core";
import { useMemo } from "react";
import { useComplexState } from "use-complex-state";

interface Props extends ReturnType<typeof useTimePickerComponent> {}

const moment = getMomentTz();

export const useTimePickerComponent = (value: Date | null = null) => {
	const now = value ? moment(value) : moment();

	const [state, actions] = useComplexState({
		initialState: {
			hours: now.hours(),
			minutes: now.minutes(),
			ones: parseInt(now.minutes().toString().padStart(2, "0").slice(1, 2)),
		},
		reducers: {
			setHours(state, { payload }) {
				state.hours = payload;
			},
			setMinutes(state, { payload }) {
				state.minutes = payload;
				const minutesInString = state.minutes.toString();
				state.ones = parseInt(
					minutesInString.toString().padStart(2, "0").slice(1, 2),
				);
			},
			setOnes(state, { payload }) {
				state.ones = payload;
				let newMinutes;
				if (state.minutes > 10) {
					newMinutes = Math.floor(state.minutes / 10) * 10 + payload;
				} else {
					newMinutes = payload;
				}
				state.minutes = newMinutes;
			},
		},
	});
	return { state, actions };
};

export const TimePickerComponent = ({ state, actions }: Props) => {
	const minutes = useMemo(() => {
		const [decena, unidad] = state.minutes
			.toString()
			.padStart(2, "0")
			.split("");
		if (parseInt(unidad) >= 5) {
			return parseInt(`${decena}5`);
		} else {
			return parseInt(`${decena}0`);
		}
	}, [state.minutes]);

	return (
		<Grid container justifyContent="center" alignContent="center" spacing={1}>
			<Grid
				item
				xs={12}
				md={3}
				container
				justifyContent="center"
				alignContent="flex-start"
			>
				<label htmlFor="hours">Hours</label>
				<select
					value={state.hours}
					onChange={(ev) => actions.setHours(parseInt(ev.target.value))}
					className="form-control user-select-none text-center overflow-hidden"
					size={24}
					name="hours"
					id="hours"
				>
					<option value="0">00</option>
					<option value="1">01</option>
					<option value="2">02</option>
					<option value="3">03</option>
					<option value="4">04</option>
					<option value="5">05</option>
					<option value="6">06</option>
					<option value="7">07</option>
					<option value="8">08</option>
					<option value="9">09</option>
					<option value="10">10</option>
					<option value="11">11</option>
					<option value="12">12</option>
					<option value="13">13</option>
					<option value="14">14</option>
					<option value="15">15</option>
					<option value="16">16</option>
					<option value="17">17</option>
					<option value="18">18</option>
					<option value="19">19</option>
					<option value="20">20</option>
					<option value="21">21</option>
					<option value="22">22</option>
					<option value="23">23</option>
				</select>
			</Grid>
			<Grid
				item
				xs={12}
				md={3}
				container
				justifyContent="center"
				alignContent="flex-start"
			>
				<label htmlFor="minutes">Minutes</label>
				<select
					name="minutes"
					id="minutes"
					value={minutes}
					onChange={(ev) => actions.setMinutes(parseInt(ev.target.value))}
					size={12}
					className="form-control user-select-none text-center overflow-hidden"
				>
					<option value="00">00</option>
					<option value="05">05</option>
					<option value="10">10</option>
					<option value="15">15</option>
					<option value="20">20</option>
					<option value="25">25</option>
					<option value="30">30</option>
					<option value="35">35</option>
					<option value="40">40</option>
					<option value="45">45</option>
					<option value="50">50</option>
					<option value="55">55</option>
				</select>
			</Grid>
			<Grid
				item
				xs={12}
				md={3}
				container
				justifyContent="center"
				alignContent="flex-start"
			>
				<label htmlFor="ones">Ones</label>
				<select
					name="ones"
					id="ones"
					value={state.ones}
					onChange={(ev) => actions.setOnes(parseInt(ev.target.value))}
					size={10}
					className="form-control user-select-none text-center overflow-hidden"
				>
					<option value="0">00</option>
					<option value="1">01</option>
					<option value="2">02</option>
					<option value="3">03</option>
					<option value="4">04</option>
					<option value="5">05</option>
					<option value="6">06</option>
					<option value="7">07</option>
					<option value="8">08</option>
					<option value="9">09</option>
				</select>
			</Grid>
		</Grid>
	);
};
